module.exports = __webpack_public_path__ + "img/zapermenu-profile.68f3f290.png";